//Utils
import { isJavascriptEnabled } from './utils/isJavascriptEnabled';
import { getFocusable } from './utils/getFocusable';
import { nextFocusable } from './utils/nextFocusable';
import { isPrintableChar } from './utils/isPrintableChar';
import { isInputable } from './utils/isInputable';
import { isSet } from './utils/isSet';
import ScrollStopListener from './utils/scrollStopListener';

//IMPORT - FUNCTIONS
import { initCarousels } from "./functions/carouselInit";
import { trackHeights } from "./functions/trackHeights";

isJavascriptEnabled();

const focusableElements = [
    'a[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'area[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe:not([disabled]):not([hidden]):not([aria-hidden])',
    'object:not([disabled]):not([hidden]):not([aria-hidden])',
    'embed:not([disabled]):not([hidden]):not([aria-hidden])',
    '[contenteditable]:not([disabled]):not([hidden]):not([aria-hidden])',
    '[tabindex]'
];
window.focusableElements = focusableElements;

const store = {
    activeLayers: [],
    activeLayer: ''
};
window.store = store;


// CAROUSELS
initCarousels();


//TRACK ELEMENT HEIGHTS
trackHeights();

window.addEventListener('resize', () => {
    trackHeights();
});
